import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-avatar-showroom',
    templateUrl: './showroom-exhibit-avatar-page.component.html',
    styleUrls: ['./showroom-exhibit-avatar-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitAvatarPageComponent {

}
